module.exports = __webpack_public_path__ + "tf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tf.svg
// module id = 1088
// module chunks = 0